import { functions } from "configs/firebase";
import { httpsCallable } from "firebase/functions";

const sendEmail = httpsCallable(functions, "sendEmail");
const sendWhatsAppNudges = httpsCallable(functions, "sendWhatsAppNudges");

export { sendEmail, sendWhatsAppNudges };
